export default "__VITE_ASSET__HOQ8sVzN__"